export const itemsViewErrorPrefix = "items-view error: ";
export const teamsTelemetryDelimiter = "_";
export const itemsViewTelemetryDelimiterRegex = /\./g;

export const scenarios = {
  prefetchListData: "documents_prefetch_list_data_v2",
  listUpdateCallback: "documents_list_update_callback_v2",
  steps: {
    succesfullyPrefetchedData: "prefetch_data_from_indexedDB_success",
    successfullyUpdatedCache: "succesfully_updated_indexedDB_data"
  },
  errorMessage: {
    indexedDbDataNotFound: "No data found in indexedDB",
    prefetchDataNotFound: "No prefetch data found in indexedDB",
    urlOrBodyMissing: "Url or Body missing",
    bodyMissing: "Body missing",
    indexedDbFetchFailed: "Failed to fetch data from indexedDB",
    cachePersistorLoadFailure: "Failed to get cache persistor instance",
    indexedDbPersistFailed: "Failed to update data in indexedDB",
    failToParseJSONResponse: "Failed to pass JSON response",
    errorResponseFromUpdateCallback:
      "Update Callback for RenderListData sent error response",
    prefetchCallFailed: "Prefetch call failed"
  }
};

export const errorCodes = {
  NOTFOUND: "404",
  NOTFOUNDSPECIAL: "[404]"
};

export const eventNames = {
  getSPFolderItemSet: "getData.getListDataAsStream.getSPFolderItemSet"
};

/**
 * Keep this map in sync with the map present in https://domoreexp.visualstudio.com/DefaultCollection/Teamspace/_git/Teamspace-Web?path=%2Fmodules%2Fsrc%2Fmsteams-web-bridge%2Fconfig%2Fitems-view-locale-bundle-plugin.js&version=GBdevelop
 */
export const teamsToItemsViewLocaleMap: { [key: string]: string } = {
  "ar-sa": "ar",
  "bg-bg": "bg",
  "ca-es": "ca",
  "cs-cz": "cs",
  "cy-gb": "cy-gb",
  "da-dk": "da",
  "de-de": "de",
  "el-gr": "el",
  "en-gb": "en-gb",
  "en-us": "en-us",
  "es-es": "es",
  "es-mx": "es-mx",
  "et-ee": "et",
  "fi-fi": "fi",
  "fil-ph": "fil-ph",
  "fr-ca": "fr-ca",
  "fr-fr": "fr",
  "he-il": "he",
  "hi-in": "hi",
  "hr-hr": "hr",
  "hu-hu": "hu",
  "id-id": "id",
  "is-is": "is",
  "it-it": "it",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "lt-lt": "lt",
  "lv-lv": "lv",
  "nb-no": "nb-no",
  "nl-nl": "nl",
  "nn-no": "nn-no",
  "pl-pl": "pl",
  "pt-br": "pt-br",
  "pt-pt": "pt-pt",
  "ro-ro": "ro",
  "ru-ru": "ru",
  "sk-sk": "sk",
  "sl-si": "sl",
  "sr-latn-rs": "sr-latn-rs",
  "sv-se": "sv",
  "th-th": "th",
  "tr-tr": "tr",
  "uk-ua": "uk",
  "vi-vn": "vi",
  "zh-cn": "zh-cn",
  "zh-tw": "zh-tw"
};

const ten = 10;
const oneMinuteInMilliseconds = 60000;
export const tenMinutesInMilliseconds = ten * oneMinuteInMilliseconds;
export const itemsViewUploadQos = {
  uploadFile: "Uploader.uploadFile",
  uploadBatch: "Uploader.uploadBatch"
};
